import { MailOutlineOutlined } from "@mui/icons-material";
import { Button, Dialog, IconButton, Tooltip } from "@mui/material";
import WholeScreenLoader from "components/WholeScreenLoader";
import { differenceInDays } from "date-fns";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { FaTimes } from "react-icons/fa";
const PreivewModal = ({ data, isFetching, open, handleClose, fetchSelectedClientData }) => {
  const handleImportSelectedData = () => {
    const selectedData = table.getSelectedRowModel().flatRows.map((row) => {
      return row.original;
    });
    fetchSelectedClientData(selectedData);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "sn",
        header: "SN",
        size: 20,
        Cell: ({ row }) => {
          return <div>{row?.index + 1}</div>;
        },
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 150,
      },
      {
        accessorKey: "number",
        header: "Number",
        size: 100,
      },
      {
        accessorKey: "gender",
        header: "Gender",
        size: 100,
      },
      {
        accessorKey: "dob",
        header: "DOB",
        size: 100,
      },
      {
        accessorKey: "passportNumber",
        header: "Passport Number",
        size: 100,
      },

      {
        accessorKey: "visaStatus",
        header: "Visa Status",
        size: 150,
      },
      {
        accessorKey: "visaExpiry",
        header: "Visa Expiry",
        size: 150,
        Cell: ({ row }) => {
          const daysUntilExpiry = differenceInDays(new Date(row?.original?.visaExpiry), new Date());
          const isExpiringSoon = daysUntilExpiry < 90;

          return (
            <>
              {row?.original?.visaExpiry ? (
                <div>
                  {" "}
                  <Tooltip
                    title={
                      isExpiringSoon
                        ? daysUntilExpiry > 0
                          ? `Visa expiring in ${daysUntilExpiry} days`
                          : "Visa expired, please contact Client"
                        : ""
                    }
                    arrow
                  >
                    <span
                      className={
                        " " +
                        (isExpiringSoon
                          ? "bg-red-400 text-white font-medium rounded-xl px-2 py-1"
                          : "")
                      }
                    >
                      {row?.original?.visaExpiry?.split(" ")[0] || "-"}
                    </span>
                  </Tooltip>{" "}
                  {isExpiringSoon && (
                    <Tooltip title={"Send Email to the Client"} arrow>
                      <IconButton
                        onClick={() => {
                          const mailtoLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${row?.original?.email}`;
                          window.open(mailtoLink, "_blank");
                        }}
                      >
                        <MailOutlineOutlined className="text-primary" />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              ) : (
                "-"
              )}
            </>
          );
        },
      },
      {
        accessorKey: "usiNumber",
        header: "USI Number",
        size: 150,
      },
      {
        accessorKey: "caseOfficer",
        header: "Case Officer",
        size: 150,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data: data || [],
    rowNumberDisplayMode: "original",
    initialState: {
      enableGlobalFilter: true,
      showGlobalFilter: true,
      density: "compact",
    },
    enablePagination: true,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnPinning: true,
    muiSkeletonProps: {
      animation: "wave",
    },
    muiLinearProgressProps: {
      color: "secondary",
    },
    muiCircularProgressProps: {
      color: "secondary",
    },

    muiTableContainerProps: {
      sx: {
        maxHeight: "50vh",
        minHeight: "50vh", // Set max height
        overflowY: "auto", // Enable vertical scrolling
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      },
    }),
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: "70vh",
          minHeight: "70vh", // Set max height
        },
      }}
    >
      <div className="flex flex-wrap mt-4">
        <div className="w-full h-full mb-12 px-4">
          <div className="flex items-center justify-between border-b pb-4">
            <h3 className="text-2xl font-bold">Preview Data ({data?.length})</h3>
            <IconButton color="primary" onClick={handleClose}>
              <FaTimes />
            </IconButton>
          </div>
          <div className="block w-full overflow-x-auto">
            {isFetching && <WholeScreenLoader open={isFetching} />}
            <MaterialReactTable table={table} />
          </div>
          <div className="flex justify-end mt-4 gap-4">
            <Button variant="contained" color="primary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleImportSelectedData}
              disabled={!table.getSelectedRowModel().rows.length > 0}
            >
              Import Selected Data
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PreivewModal;
